import { Controller } from "@hotwired/stimulus"

// Enhances the mobile navigation drawer (a popover toggled natively via
// popovertarget). On open/close it reflects state to the trigger, marks the
// page content inert so keyboard/screen-reader users can't reach it behind the
// drawer, and moves focus into the drawer.
export default class extends Controller {
  static targets = ["trigger", "drawer", "content"]

  toggled(event) {
    const open = event.newState === "open"
    this.triggerTarget.setAttribute("aria-expanded", open)
    this.contentTarget.inert = open
    if (open) this.drawerTarget.querySelector("a, button").focus()
  }
}
